export default __webpack_public_path__ + "static/media/news-08.67ef9088.jpg";